import {authHeader, ApiConfigs} from "../_helpers";

export const cartItemService = {
    getAll,
    show,
    create,
    delete: _delete,
    update,
    filter
};

function getAll() {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.cartItem.getAll}`, requestOptions)
        .then(
            handleResponse
        );
}


function filter(payload:object) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
        body: JSON.stringify(payload),
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.cartItem.getAll}`, requestOptions)
        .then(
            handleResponse
        );
}

function show(id: string) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.cartItem.show.replace(':id', id)}`, requestOptions)
        .then(
            handleResponse
        );
}

function create(cartId: string, payload:object ){
    const requestOptions = {
        method: "POST",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.cartItem.create.replace(':id', cartId)}`, requestOptions)
        .then(
            handleResponse
        );
}

function _delete(cartId: string, productId: string){
    const requestOptions={
        method:"DELETE",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" },

    }

    return fetch(`${ApiConfigs.base_url+ApiConfigs.cartItem.delete.replace(':id', cartId).replace(':id', productId)}`, requestOptions)
        .then(handleResponse);
}

function update(id_cart: string, id_item: string, payload: object){
    const requestOptions={
        method:"PUT",
        credentials : 'include' as RequestCredentials,
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    }

    return fetch(`${ApiConfigs.base_url+ ApiConfigs.cartItem.update.replace(':id_cart', id_cart).replace(':id_item', id_item)}`, requestOptions)
    .then(handleResponse);
}


function handleResponse(response: Response) {
    return response.json().then((rep) => {
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                localStorage.removeItem("user");
                location.reload();
            }
            const error = (rep) || response.statusText;
            return Promise.reject(error);
        }
        return rep;
    });
}